import { getFile } from "@/utils/downloadFile";
import JSZip from "jszip";
import { getWorkDetail, getSceneSources, downloadZip } from "@/api/work";
import { baseApi } from "@/config";
import FileSaver from "file-saver";
import path from "path";
import {message} from "ant-design-vue";
import i18n from '@/i18n/langs'

let errorQueue = [];
let retry = 0;
let promises = [];

export function download(record) {
    message.loading({ content: i18n.tc('message.offlineDownloadResource'), duration: 0 });
    getSceneSources({id: record.id}).then(data => {
        let downloadElement = document.createElement("a");
        downloadElement.href = data.data.url;
        document.body.appendChild(downloadElement);
        downloadElement.click(); //點擊下載
        document.body.removeChild(downloadElement); //下載完成移除元素
        message.destroy();
    }).catch(err => {
        console.log(err);
        message.destroy();
        message.error({ content: i18n.tc('message.offlineDownloadFail') });
    })
}
//老的離線下載
export function download1(record) {
    message.loading({ content: i18n.tc('message.offlineDownloadApp'), duration: 0 });
    getFile("/offline.zip").then((data) => {
      message.destroy();
      message.loading({ content: i18n.tc('message.offlineDownloadResource'), duration: 0 });
      JSZip.loadAsync(data).then((zip) => {
        //下載場景圖片
        getSceneSources({id: record.id}).then(data => {
          //下載zip包
          const url = new URL(data.data.url);
          let pathname = url.pathname;
          downloadZip(pathname).then(response => {
            zip.loadAsync(response)
            .then(function (newzip) {
              //處理其他資源
              handleOtherSources(newzip, record);
            });
          }).catch(err => {
            console.log("====",err);
            message.destroy();
            message.error({ content: i18n.tc('message.offlineDownloadFail') });
          })

        }).catch(err => {
          console.log(err);
          message.destroy();
          message.error({ content: i18n.tc('message.offlineDownloadFail') });
        })

      });
    });
  }

  function handleOtherSources(zip, record) {
    //get work details
    getWorkDetail({ id: record.id }).then((res) => {
      var work = res.data;
      // var promises = [];
      //處理基本資源
      if (work.base.thumb_path) {
        const thumb_path = work.base.thumb_path + getImageVersion();
        let processRet = processFile(zip, thumb_path);
        promises.push(processRet.promise);
        work.base.thumb_path = processRet.localUrl;
      }

      //處理沙盤資源
      work.sandtable.forEach((s) => {
        if (s.url) {
          let processRet = processFile(zip, s.url);
          // promises.push(processRet.promise);
          promises.push(s.url);
          s.url = processRet.localUrl;
        }
      });

      //處理導覽資源
      work.guide.forEach((g) => {
        if (g.start_img) {
          let processRet = processFile(zip, g.url);
          // promises.push(processRet.promise);
          promises.push(g.url);
          g.start_img = processRet.localUrl;
        }
        if (g.end_img) {
          let processRet = processFile(zip, g.url);
          // promises.push(processRet.promise);
          promises.push(g.url);
          g.end_img = processRet.localUrl;
        }
        g.points.forEach((p) => {
          if (p.music_url) {
            let processRet = processFile(zip, g.music_url);
            // promises.push(processRet.promise);
            promises.push(g.music_url);
            g.music_url = processRet.localUrl;
          }
        });
      });

      //處理廣告資源
      if (work.ads.logo) {
        let processRet = processFile(zip, work.ads.logo);
        // promises.push(processRet.promise);
        promises.push(work.ads.logo);
        work.ads.logo = processRet.localUrl;
      }
      if (work.ads.bgm) {
        let processRet = processFile(zip, work.ads.bgm);
        // promises.push(processRet.promise);
        promises.push(work.ads.bgm);
        work.ads.bgm = processRet.localUrl;
      }
      if (work.ads.bgv) {
        let processRet = processFile(zip, work.ads.bgv);
        // promises.push(processRet.promise);
        promises.push(work.ads.bgv);
        work.ads.bgv = processRet.localUrl;
      }
      if (work.ads.cover.pc) {
        let processRet = processFile(zip, work.ads.cover.pc);
        // promises.push(processRet.promise);
        promises.push(work.ads.cover.pc);
        work.ads.cover.pc = processRet.localUrl;
      }
      if (work.ads.cover.mob) {
        let processRet = processFile(zip, work.ads.cover.mob);
        // promises.push(processRet.promise);
        promises.push(work.ads.cover.mob);
        work.ads.cover.mob = processRet.localUrl;
      }
      if (work.ads.fix_logo.land) {
        let processRet = processFile(zip, work.ads.fix_logo.land);
        // promises.push(processRet.promise);
        promises.push(work.ads.fix_logo.land);
        work.ads.fix_logo.land = processRet.localUrl;
      }
      if (work.ads.fix_logo.sky) {
        let processRet = processFile(zip, work.ads.fix_logo.sky);
        // promises.push(processRet.promise);
        promises.push(work.ads.fix_logo.sky);
        work.ads.fix_logo.sky = processRet.localUrl;
      }

      zip.file("work.json", JSON.stringify(res), { string: true }); // 添加work json文件

      getFile(
        `${baseApi}/offlineTourXml?uuid=${record.uuid}`
      ).then((data) => {
        zip.file("tour.xml", data, { binary: true });
        //批量下載其他圖片資源
        requestAll(zip, work);
      });
    });
  }

  function requestAll(zip, work) {

    function handlequeue() {
      if (promises.length > 0) {
        console.log("--update queue--");
        doRequest();
      } else {
        // console.log(work);
        message.destroy();
        message.loading({
          content: i18n.tc('message.offlineDownloadZip'),
          duration: 0,
        });
        zip.generateAsync({ type: "blob" }).then((content) => {
          // 生成二進制流
          message.destroy();
          FileSaver.saveAs(content, `${work.base.name}.zip`); // 利用file-saver保存文件
        });
      }
    }
  
    function doRequest() {
      let currQueue = [];
      const waitLength = promises.length
      if(waitLength > 0) {
        const len = waitLength > 5 ? 5 : waitLength;
        for(let k = 0; k < len; k++) {
          const url = promises.shift();
          const promise = processFile(zip, url, true).promise;
          currQueue.push(promise);
        }
      }
      // console.log("currQueue==",currQueue);
      console.log("promises.length==", waitLength);
  
      Promise.all(currQueue)
      .then(() => {
        handlequeue(zip, work);
      })
      .catch(() => {
        console.error("==promise all error==", waitLength)
        message.destroy();
        message.error({ content: i18n.tc('message.offlineDownloadFail') });
      });
    }
  
    //do it
    doRequest();
  
  }

  function processFile(zip, fileUrl, needPromise = false) {
    let promise = null;
    let localUrl = "";
    try {
      const url = new URL(fileUrl);
      let pathname = url.pathname;
      let dirname = path.dirname(pathname);
      let filename = path.basename(pathname);
      let dir = path.join("resource", dirname);
      localUrl = path.join(dir, filename);
      if(needPromise) {
        promise = getFile(url).then((data) => {
          zip.folder(dir).file(filename, data, { binary: true }); // 逐個添加文件
        }).catch(url => {
          errorQueue.push(fileUrl)
        });
      }
    } catch (e) {
      return { promise: promise, localUrl: localUrl, url: fileUrl };
    } finally {
      return { promise: promise, localUrl: localUrl, url: fileUrl };
    }
  
    // return { promise: promise, localUrl: localUrl, url: fileUrl };
  }

  //切圖參數處理
function handleParams(len) {
  let myArgs = [];
  for (let i = 1; i <= len; i++) {
    myArgs.push(i + "")
  }
  return myArgs
}

function getImageVersion() {
  const date = new Date();
  const v = "?v=" + date.getFullYear() + "" + (date.getMonth() + 1) + "" + date.getDate();
  return v;
}